import Panzoom, { PanzoomObject, PanzoomOptions } from "@panzoom/panzoom";
import { Subject } from "rxjs";

export interface LHPEPanzoomObject extends PanzoomObject {
  onInit: Subject<void>;
  onDestroy: Subject<void>;
}

export function LHPEPanzoom(
  elem: HTMLElement | SVGElement,
  options: Omit<PanzoomOptions, "force"> | undefined,
): LHPEPanzoomObject {
  const _panzoom = Panzoom(elem, options);
  const self: {
    onInit: Subject<void>;
    onDestroy: Subject<void>;
    destroy: () => void;
  } = {
    onInit: new Subject<void>(),
    onDestroy: new Subject<void>(),
    destroy: () => {
      let inDOM = document.body.contains(elem);

      const panzoomDestroyedMutationObserver = new MutationObserver(
        (mutations) => {
          if (document.body.contains(elem)) {
            if (!inDOM) {
              // console.log("element inserted");
            }
            inDOM = true;
          } else if (inDOM) {
            inDOM = false;
            self.onDestroy.next();
            self.onDestroy.complete();
            panzoomDestroyedMutationObserver.disconnect();
          }
        },
      );

      panzoomDestroyedMutationObserver.observe(document.body, {
        childList: true,
        subtree: true,
      });

      _panzoom.destroy();
    },
  };

  const panzoomInitiatedMutationObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (
        elem.style.userSelect === "none" &&
        elem.style.touchAction === "none"
      ) {
        self.onInit.next();
        self.onInit.complete();
        panzoomInitiatedMutationObserver.disconnect();
      }
      break;
    }
  });

  panzoomInitiatedMutationObserver.observe(elem, {
    attributes: true,
    attributeFilter: ["style"],
  });

  return { ..._panzoom, ...self };
}
